export default __webpack_public_path__ + "static/media/hero_image.5a9eff44.png";